(function () {
    angular.module('app')
        .directive('preventDefaultIf', preventDefaultIf);

    /*
        Preventsdefault if the condition is true (function or bool)
        This is useful when you want to disable href or ui-sref attributes
     */
    preventDefaultIf.$inject = ['$parse', '$rootScope'];

    function preventDefaultIf($parse, $rootScope) {
        return {
            // this makes sure that preventDefaultIf is compiled (prioritized) before ngClick
            priority: 100,
            restrict: 'A',
            compile: function ($element, attr) {
                var fn = $parse(attr.preventDefaultIf);
                return {
                    pre: function link(scope, element) {

                        element.on('click', function (event) {
                            var callback = function () {
                                if (fn(scope, {$event: event})) {

                                    event.stopImmediatePropagation();
                                    // prevents href
                                    event.preventDefault();
                                    return false;
                                } else {
                                    return true;
                                }
                            };
                            if ($rootScope.$$phase) {
                                scope.$evalAsync(callback);
                            } else {
                                scope.$apply(callback);
                            }
                        });
                    },
                    post: function () {
                    }
                }
            }
        }
    }
})();